export default '/build/74bf98da.svg'